let endingSpawned = false;
let triggeredEnd = false;

export const resetEnding = () => {
  endingSpawned = false;
  triggeredEnd = false;
};

export const SystemEnding = ({ stage = 0, onEnded = () => {} }) => {
  const score = useScore();

  useEffect(() => {
    const player = players.entities[0];
    if (!player) return;

    if (score >= SCORE_LIMIT) {
      const playerX = player.position.x;

      // Check if score has reached limit and ending hasn't been spawned yet
      if (score >= SCORE_LIMIT && !endingSpawned) {
        // Remove obstacles and collectibles that are in front of the player and not visible
        cleanupObjectsInFront(playerX);

        // Add ending items for the current area
        addEndings(stage, playerX + ENDING_DISTANCE);

        endingSpawned = true;
      }
      console.log('SYSTEN ENDING: ', score, SCORE_LIMIT, endingSpawned);
    }
  }, [score]);

  useFrame(() => {
    // Stop player from moving when the player reaches the position of the last ending item
    const player = players.entities[0];
    if (!player || !endingSpawned) return;

    // Find the last ending item
    for (const ending of lastEnding) {
      if (player.position.x >= ending.position.x) {
        player.velocity.x = 0;
        // console.log('SystemEnding', 'add stop');
        ECS.world.addComponent(player, 'stop', true);
        if (!triggeredEnd) {
          onEnded();
          triggeredEnd = true;
        }
      }
    }
  });
};
